export default __webpack_public_path__ + "static/media/option.758d592e.PNG";